import { useCallback, useState } from "react";
import { OspToast } from "@ospweb/sdk-ui";
import log from "logbeacon";

import { ROUTER_PATH } from "@/src/config";
import { getPaymentCheckErrorMessage, usePayment } from "@/src/hooks";
import { sendGtmOrApp } from "@/src/utils/sendGtmOrApp";
import { MemberProduct } from "@/src/features/api/memberApi";

interface UseMemberStripeCheckoutParams {
  data?: MemberProduct[];
}

export const useMemberStripeCheckout = ({
  data,
}: UseMemberStripeCheckoutParams) => {
  const { handlePaymentCheck } = usePayment();
  const [isPaying, setIsPaying] = useState(false);

  const handleStripeClick = useCallback(
    async (planId: string) => {
      setIsPaying(true);
      const currentPlan = data?.find((item) => item.id === planId);
      const price = currentPlan?.price;

      const { data: paypalData, error } = await handlePaymentCheck(planId);
      log.info("[Member][trace][pay] stripe result", paypalData, error);
      setIsPaying(false);

      if (!error) {
        const eventData = {
          event: "begin_checkout",
          ecommerce: {
            value: price,
            currency: "USD",
            items: [
              {
                item_id: planId,
                item_name: currentPlan?.name,
                price,
                quantity: 1,
              },
            ],
          },
        };

        sendGtmOrApp(eventData);
        log.debug("[Subscription] sendGTMEvent success, 上报信息为", eventData);
        // 跳转前清理当前 history 条目，Stripe 页点浏览器返回时会回到无参数的 /member
        window.history.replaceState({}, "", ROUTER_PATH.MEMBER);
        window.location.href = (paypalData as string) || "";
        return;
      }

      const errMsg = getPaymentCheckErrorMessage({
        code: error.code,
        msg: error.msg,
      });
      OspToast.error({
        content: errMsg,
      });
    },
    [data, handlePaymentCheck],
  );

  return {
    isPaying,
    handleStripeClick,
  };
};
